/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Adal from 'vue-adal'
import store from './store'
import vuetify from './plugins/vuetify'
import router from './router'

Vue.config.productionTip = false

Vue.use(Adal, {
  config: {
    tenant: 'gopuff.us',
    clientId: 'd44dde0a-5777-4d4a-900d-b9e80c3a6026',
    redirectUri: process.env.URL,
    cacheLocation: 'localStorage'
  },
  requireAuthOnInitialize: false,
  router: router
})

// Vue.use({
//   install (vue, opts = {}) {
//     // Configures an axios http client with a interceptor to auto-acquire tokens
//     vue.prototype.$graphApi = AxiosAuthHttp.createNewClient({
//       // Required Params
//       axios: axios,
//       resourceId: graphApiResource, // Resource id to get a token against
//
//       // Optional Params
//       router: router, // Enables a router hook to auto-acquire a token for the specific resource
//
//       baseUrl: graphApiBase, // Base url to configure the client with
//       onTokenSuccess (http, context, token) {
//         // Token success hook
//         // When an attempt to retrieve a token is successful, this will get called.
//         // This enables modification of the client after a successful call.
//         if (context.user) {
//           // Setup the client to talk with the Microsoft Graph API
//           // http.defaults.baseURL = `${graphApiBase}/${context.user.profile.tid}`
//           console.log(`user: ${context.user}`)
//         }
//       },
//
//       onTokenFailure (error) {
//         // Token failure hook
//         // When an attempt to retrieve a token is not successful, this will get called.
//         console.log(error)
//       }
//     })
//   }
// })

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
